import React from 'react';
import { withRouter } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title } from 'root/admin/components';

import store from 'root/admin/store';
import { Form, Field, Loader } from '@smartplatform/ui';

const EditYears = ({ match, rootPath, tabName }) => {
	const { id, yid } = match.params;
	const options = {};
	const record = useGetRecord({ model: 'AwardYear', id: yid, options, tabName });

	const beforeSave = record => {
		record.awardId = id;
	};

	if (!record) {
		return <Loader />;
	}

	return (
		<>
			<Title record={record} name="Год присуждения" />

			<Form record={record} rootPath={`${rootPath}/${id}`} beforeSave={beforeSave}>
				<Field property="name" label="Имя" />
			</Form>
		</>
	);
};

export default withRouter(EditYears);
